import { render, staticRenderFns } from "./AssignmentRightPanel.vue?vue&type=template&id=5a4f671c&scoped=true&"
import script from "./AssignmentRightPanel.vue?vue&type=script&lang=js&"
export * from "./AssignmentRightPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRightPanel.vue?vue&type=style&index=0&id=5a4f671c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f671c",
  null
  
)

export default component.exports